
const routing_numbers = document.getElementsByClassName('js-routing-number-copy');
for(var i=0; i<routing_numbers.length; i++) {
    const el = routing_numbers[i];

    const copy_trigger = el.querySelector('.js-routing-number-copy-trigger');
    copy_trigger.addEventListener('click', function(){
        /* Get the text field */
        
        var copyText = el.querySelector(".js-routing-number-copy-input");
        // console.log(copyText);
        try {
            /* Select the text field */
            navigator.clipboard.writeText(copyText.value)
                .then(() => { alert(`Copied!`) })
                .catch((error) => { alert(`Copy failed! ${error}`) })
        } catch(error) {
            console.log(error);
        }
        
    });
}
